/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const isLightColor = (color) => {
  if (!color || typeof color !== 'string') return false;

  const hex = color.replace('#', '');
  let red;
  let green;
  let blue;

  if (hex.length === 3) {
    red = parseInt(hex[0] + hex[0], 16);
    green = parseInt(hex[1] + hex[1], 16);
    blue = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    red = parseInt(hex.substring(0, 2), 16);
    green = parseInt(hex.substring(2, 4), 16);
    blue = parseInt(hex.substring(4, 6), 16);
  } else {
    return false;
  }

  const brightness = Math.sqrt(
    red * red * 0.299 + green * green * 0.587 + blue * blue * 0.114
  ) / 255;

  return brightness > 0.7;
};
